import { envConfig } from "@/config/env";

export const isExternalLink = (href: string): boolean => {
  return (
    (href.startsWith("http://") || href.startsWith("https://")) &&
    !href.includes(envConfig.NEXT_PUBLIC_APP_BASE_URL)
  );
};
